export default __webpack_public_path__ + "static/media/fpb50200.ad9e6dcc.png";